import axios from "src/lib/axios";
import { getParams } from "src/common/api";

export const getSalesBySeller = async (startDate, endDate) => {
  const params = getParams({
    startDate,
    endDate,
  });
  const { data: response } = await axios.get(
    `/dashboard/admin/sales/seller?${params}`,
  );
  return response.data;
};

export const getSalesByCategory = async (startDate, endDate) => {
  const params = getParams({
    startDate,
    endDate,
  });
  const { data: response } = await axios.get(
    `/dashboard/admin/sales/category?${params}`,
  );
  return response.data;
};

export const getTotalSalesPerDay = async (
  sellerId,
  categoryId,
  startDate,
  endDate,
) => {
  const params = getParams({
    sellerId,
    categoryId,
    startDate,
    endDate,
  });
  const { data: response } = await axios.get(
    `/dashboard/admin/sales/total?${params}`,
  );
  return response.data;
};
